// extracted by mini-css-extract-plugin
module.exports = {"orderItem":"Orders_orderItem__1ukrE","borderBottomNotLast":"Orders_borderBottomNotLast__1hc8B","borderBottom":"Orders_borderBottom__wnZzy","smallText":"Orders_smallText__2R9yC","greyBg":"Orders_greyBg__jOHDc"};
    if(module.hot) {
      // 1686459253899
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  